import constants from "../constants";

const {
  UPDATE_PROJECT_MANAGERS,
  ADD_PROJECT_MANAGER,
  EDIT_PROJECT_MANAGER,
  REMOVE_PROJECT_MANAGER,
} = constants;

const initialState = {};

export default (state = initialState, action) => {
  if (!action) return state;
  const { type } = action;
  switch (type) {
    case UPDATE_PROJECT_MANAGERS: {
      return { ...action.data };
    }
    case ADD_PROJECT_MANAGER: {
      const { projectManager, projectManagerUid } = action.data || {};
      if (projectManager && projectManagerUid) {
        return { ...state, [projectManagerUid]: projectManager };
      }
      return state;
    }

    case EDIT_PROJECT_MANAGER: {
      const { projectManager, projectManagerUid } = action.data || {};
      if (projectManager && projectManagerUid) {
        return { ...state, [projectManagerUid]: projectManager };
      }
      return state;
    }

    case REMOVE_PROJECT_MANAGER: {
      const projectManagerUid = action?.data?.projectManagerUid;

      if (!projectManagerUid) return state;

      const nextState = { ...state };
      delete nextState[projectManagerUid];
      return nextState;
    }

    default:
      return state;
  }
};
